module.exports = __webpack_public_path__ + "img/img_5.1bf57597.png";